module.exports = __webpack_public_path__ + "static/media/mouse.680b1c77.svg";